import { Theme } from "@mui/material";

export function permissionsTableStyles(theme: Theme) {
  return {
    topLevelTableContainer: {
      "& td": {
        verticalAlign: "top"
      },
      "& thead tr th.MuiTableCell-root": {
        fontWeight: "bold",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
      }
    },
    childTableContainer: {
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    borderedTable: {
      border: `1px solid ${theme.palette.divider}`
    },
    tinyTable: {
      "& > tbody > tr > td": {
        padding: "1px"
      },
      "& > tbody > tr:last-child > td": {
        borderBottom: "none"
      }
    }
  };
}
